<template>
  <v-row class="mx-0 px-0 dense pb-0">
    <v-col  class="pb-0 px-0">
      <v-card-subtitle class="px-0 text--black">
        This is the list of individuals invited by {{ currentSponsor.name }} to participate as their representatives in your event.
      </v-card-subtitle>
      <v-container fluid>
        <v-data-table :headers="headers" >
          <!-- Customize your table content and slots as needed -->
        </v-data-table>
      </v-container>
    </v-col>
  </v-row>
</template>
<script>
import Sponsor from "@/models/Sponsor";

export default {
  props: {
    currentSponsor: {
      type: Sponsor,
      required: true
    },
  },
  data() {
    return {
      headers: [
        {
          text: "Name",
          value: "name",
          align: "start",
        },
        {
          text: "Email",
          value: "email",
          align: "start",
        },
        {
          text: "Job Title",
          value: "job_title",
          align: "start",
        },
        {
          text: "Invitation Type",
          value: "invitation_type",
          align: "start",
        },
        {
          text: "Status",
          value: "status",
          align: "start",
        },
        {
          text: "Actions",
          value: "actions",
          align: "start",
        },
        {
          text: "Actions",
          value: "actions",
        }
      ]
    }
  }
}
</script>
